import React from 'react';
import { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import queryString from "query-string";
import { addUserToTeam, getProfile } from '../../services/userService';
import { connect } from 'react-redux';
import { setCurrentUser } from "../../redux/user/user.actions";
import { withRouter } from 'react-router-dom';
import Loader from '../../utils/loader';
import _ from 'lodash';
import userService from "../../services/userService";

const SocialMediaAuth = ({ location, setCurrentUser, history }) => {
    const [userID, setuserID] = useState('');
    const [team, setTeam] = useState({ referedEmail: '', accountType: 'Personal' });
    const [loginSuccess, setLoginSuccess] = useState(false)

    useEffect(() => {
        const { token, userID } = queryString.parse(
            location.search
        );
        if (!token) {
            history.push('/login');
        }
        localStorage.setItem('token', token);
        sessionStorage.setItem('token', token);
        setuserID(userID);
        setLoginSuccess(true)
    }, [location]);


    const fetchUserDetails = async (data) => {
        try {
            console.log(data, "data for fetchuser");
            const response = await userService.fetchUserData(data)
            console.log(response, "res from fetch userdata");
            const userData = response.user;
            console.log(userData, "userData");
            storeUserData(userData);
        } catch (error) {
            console.error('Failed to fetch user data:', error);
        }
    };
    const storeUserData = (userData) => {
        console.log(userData,"---userData");
        if (userData) {
            localStorage.setItem('currentUserEmail', userData.email);
            localStorage.setItem('accountType', userData.accountType);
            localStorage.setItem('userId', userData._id);
            localStorage.setItem('Role', userData.Role);
            localStorage.setItem('organizationId', userData.organizationId);
            sessionStorage.setItem('currentUserEmail', userData.email);
            sessionStorage.setItem('accountType', userData.accountType);
            sessionStorage.setItem('userId', userData._id);
            sessionStorage.setItem('Role', userData.Role);
            sessionStorage.setItem('organizationId', userData.organizationId);
        }
    };
    if (loginSuccess === true) {
        console.log("calling fetch user");
        const data = {
            userId : userID
        }
        console.log(data,"data..");
        fetchUserDetails(data);
    }

    useEffect(() => {
        const emptyTeam = _.some(team, _.isEmpty);
        console.log("emptyTeam", emptyTeam);
        console.log("Team===>", team);
        if (!emptyTeam) {
            console.group("Now add to Team");
            addNewUserToRespectiveTeam(team.referedEmail, team.accountType);
        } else {
            console.group("all are empty");
        }
    }, [team])

    useEffect(() => {
        let referedEmail = localStorage.getItem("referedEmail") !== "undefined" || null
            ? localStorage.getItem("referedEmail")
            : "";
        let accountType = localStorage.getItem("accountType") !== "undefined" || null
            ? localStorage.getItem("accountType")
            : "";
        console.log(referedEmail, accountType);
        if (referedEmail) {
            if (accountType) {
                setTeam({ referedEmail, accountType });
            } else {
                setTeam({ referedEmail });
            }
        }
    }, []);




    const getUserProfile = async () => {
        const profile = await getProfile();
        console.log(profile);
        setCurrentUser({ ...profile.data });
        if (profile.isAdmin) {
            return history.push('/admindashboard');
        } else if (profile.isSubAdmin) {
            // return history.push('/subAdminManageUser');
            return history.push('/subAdminDashboard');
        } else {
            return history.push('/dashboard');
        }
    }

    useEffect(() => {
        if (userID) {
            getUserProfile();
        }
    }, [userID]);
    const addNewUserToRespectiveTeam = async (referedEmail, accountType) => {
        console.log('addNewUserToRespectiveTeam', referedEmail, accountType);
        const response = await addUserToTeam({ referedEmail, accountType });
        if (response.status === 200) {
            localStorage.removeItem("accountType");
            localStorage.removeItem("referedEmail");
        } else {
            //do something
        }
    }
    return (
        <Loader />
    );
}
const mapDispatchToProps = (dispatch) => ({
    setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});

export default connect(null, mapDispatchToProps)(withRouter(SocialMediaAuth));